export const BookingTypes = {
  UPCOMING: 'UPCOMING',
  HISTORY: 'HISTORY',
};
